import { useEffect, useState } from "react";
import { ListChecks } from "@phosphor-icons/react";
import api from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";

const ACTION_COLOR = {
  crear: "bg-success/10 text-success border-success/30",
  editar: "bg-info/10 text-info border-info/30",
  eliminar: "bg-danger/10 text-danger border-danger/30",
  capturar: "bg-warning/10 text-warning border-warning/30",
  login: "bg-muted text-muted-foreground border-border",
};

export default function Auditoria() {
  const [logs, setLogs] = useState([]);
  const [action, setAction] = useState("all");

  const load = () => {
    const q = action !== "all" ? `?action=${action}` : "";
    api.get(`/audit-logs${q}`).then((res) => setLogs(res.data));
  };
  useEffect(() => { load(); }, [action]);

  return (
    <div className="mx-auto max-w-[1300px] space-y-6">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div>
          <h1 className="font-heading text-3xl font-bold tracking-tight">Bitácora de Auditoría</h1>
          <p className="mt-1 text-sm text-muted-foreground">Registro de acciones de los usuarios en el sistema.</p>
        </div>
        <Select value={action} onValueChange={setAction}>
          <SelectTrigger className="h-9 w-[180px]" data-testid="audit-action-filter"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Todas las acciones</SelectItem>
            <SelectItem value="login">Inicio de sesión</SelectItem>
            <SelectItem value="crear">Crear</SelectItem>
            <SelectItem value="editar">Editar</SelectItem>
            <SelectItem value="eliminar">Eliminar</SelectItem>
            <SelectItem value="capturar">Captura</SelectItem>
          </SelectContent>
        </Select>
      </div>

      <div className="overflow-hidden rounded-xl border border-border">
        <table className="w-full text-sm" data-testid="audit-table">
          <thead className="bg-accent/50 text-left text-xs uppercase tracking-wide text-muted-foreground">
            <tr>
              <th className="px-4 py-3">Fecha / Hora</th>
              <th className="px-4 py-3">Usuario</th>
              <th className="px-4 py-3">Acción</th>
              <th className="px-4 py-3">Entidad</th>
              <th className="px-4 py-3">Detalle</th>
              <th className="px-4 py-3">IP</th>
            </tr>
          </thead>
          <tbody>
            {logs.map((l) => (
              <tr key={l.id} className="border-t border-border hover:bg-accent/30">
                <td className="px-4 py-2.5 font-mono text-xs text-muted-foreground">
                  {new Date(l.timestamp).toLocaleString("es-MX")}
                </td>
                <td className="px-4 py-2.5">{l.user_name || l.user_email}</td>
                <td className="px-4 py-2.5">
                  <Badge variant="outline" className={ACTION_COLOR[l.action] || ACTION_COLOR.login}>{l.action}</Badge>
                </td>
                <td className="px-4 py-2.5 text-muted-foreground">{l.entity}</td>
                <td className="px-4 py-2.5 text-muted-foreground">{l.detail}</td>
                <td className="px-4 py-2.5 font-mono text-xs text-muted-foreground">{l.ip}</td>
              </tr>
            ))}
            {logs.length === 0 && (
              <tr><td colSpan={6} className="px-4 py-10 text-center text-muted-foreground">Sin registros.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
